import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
import { parse, stringify } from 'qs'

import { routes } from './routes'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	parseQuery: parse,
	stringifyQuery: stringify,
	routes,
	scrollBehavior: (to, from, savedPosition) => {
console.log('scrollbehavior', { to, from , savedPosition, })
		if (from.name != 'home' && to.name != 'home') {
			const dialog = document.querySelector('.home__dialog')
			if (dialog) {
				dialog.scrollTo({top: 0, smooth: true})
			}
		}
		if (to.name == 'home' && to.path != '/') {
			document.querySelector('#home')?.scrollIntoView({behavior: 'smooth'})
		}

		return savedPosition
	},
})

router.beforeEach((to, from, next) => {
	window.history.stack = window.history?.stack || [from?.path]
console.log('beforeEach', { to, }, window.history.stack)
	window.history.stack.push(to.path)
	return next()
})
export default router
